import PropTypes from 'prop-types';

export const ACTIVE_STEP = 'app/Partners/ACTIVE_STEP';
export const CALENDLY_LINK = 'https://meetings.hubspot.com/hugo-bazin';

export const partnersReducerPropTypes = PropTypes.shape({
  activeStep: PropTypes.string,
});
